import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { useLenis } from "@/components/motion";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Solutions from "@/pages/Solutions";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import Portfolio from "@/pages/Portfolio";
import ProjectDetail from "@/pages/ProjectDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Careers from "@/pages/Careers";
import ContactPage from "@/pages/ContactPage";
import Legal from "@/pages/Legal";
import Sitemap from "@/pages/Sitemap";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";
import Norbit from "@/pages/Norbit";
import Reach from "@/pages/Reach";
import Guardian from "@/pages/Guardian";
import WebDevelopment from "@/pages/WebDevelopment";
import SoftwareDevelopment from "@/pages/SoftwareDevelopment";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  useLenis();
  return (
    <AuthProvider>
      <Toaster theme="light" position="bottom-right" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/norbit" element={<Norbit />} />
          <Route path="/reach" element={<Reach />} />
          <Route path="/guardian" element={<Guardian />} />
          <Route path="/services/cybersecurity" element={<Guardian />} />
          <Route path="/services/technology-consultancy" element={<Navigate to="/services/consultancy" replace />} />
          <Route path="/services/iot-automation" element={<Navigate to="/services/iot-solutions" replace />} />
          <Route path="/services/erp-solutions" element={<Navigate to="/services/erp" replace />} />
          <Route path="/services/mobile-app-development" element={<Navigate to="/services/mobile-apps" replace />} />
          <Route path="/services/custom-software" element={<Navigate to="/services/software-development" replace />} />
          <Route path="/services/software-development" element={<SoftwareDevelopment />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/:slug" element={<IndustryDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:slug" element={<ProjectDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/legal/:type" element={<Legal />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
